import * as React from 'react';
import PageStore from '@/stores/page';
import doLog from '@/common/log';
import './index.less';
import MyLazyComponent from '@/common/lazy-load';

interface PropsType {
  i18n: { [key: string]: string };
  trade: {
    returnAndRefundsInfo: {
      content: string;
      contentAction: string;
      hasEasyReturn: boolean;
      hasRefunds: boolean;
    };
  };
  product: {
    productId: number;
  };
}

const { useState } = React;
export default function Payments(props: PropsType) {
  const [visible, setVisible] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const { trade, i18n, product } = props;
  const pageStore = PageStore((state) => state);
  const { isLoaded } = pageStore;

  if (!trade?.returnAndRefundsInfo) return null;
  const { returnAndRefundsInfo } = trade;
  if (!returnAndRefundsInfo?.content) return null;
  const secondScreen = PageStore((state) => state.secondScreen);
  const IframeDialog = MyLazyComponent(() => import('../../common/dialog-iframe'));

  return (
    <div className="product-ta-content" data-taplus="returnRefunds">
      <p className="ta-content-left">
        <img src="//s.alicdn.com/@img/imgextra/i3/O1CN01N1uHPt25tWcYOqTGz_!!6000000007584-2-tps-40-42.png" />
        <span>{i18n['detail_ta_returnstitle']}</span>
      </p>
      <div className="ta-content-right">
        {returnAndRefundsInfo.content && (
          // 支持 easy return
          <p>
            <span
              dangerouslySetInnerHTML={{
                __html: returnAndRefundsInfo.content,
              }}
            ></span>
            &nbsp;
            <span
              className="blue-font"
              onClick={() => {
                doLog('/sc.details.taEasyReturn', `second=${secondScreen}`);
                setIframeUrl(returnAndRefundsInfo.contentAction);
                setVisible(true);
              }}
            >
              {i18n['detail_ta_view_details']}
            </span>
          </p>
        )}
      </div>
      {isLoaded && (
        <IframeDialog
          iframeUrl={iframeUrl}
          visible={visible}
          setVisible={setVisible}
          productId={product.productId}
          action="returnRefundsViewDetail"
          dialogClass="promotion-dialog hide-close"
        />
      )}
    </div>
  );
}
